import { Document, Font, Link, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import { formatDateToMMYYYY } from "../Utils/Resume/DateFormattingUtils";
import {
  convertBulletsForPDF,
  convertToBulletPoints,
  removeBulletPoints,
} from "../Utils/Resume/TextFormattingUtils.js";

// Register Roboto font from Google Fonts CDN
Font.register({
  family: "Roboto",
  fonts: [
    {
      src: "https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Mu4mxP.ttf",
      fontWeight: 400,
    },
    {
      src: "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmEU9fBBc9.ttf",
      fontWeight: 500,
    },
    {
      src: "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmWUlfBBc9.ttf",
      fontWeight: 700,
    },
    {
      src: "https://fonts.gstatic.com/s/roboto/v30/KFOkCnqEu92Fr1Mu51xIIzc.ttf",
      fontStyle: "italic",
    },
  ],
});

// Register Open Sans
Font.register({
  family: "Open Sans",
  fonts: [
    { src: "https://fonts.gstatic.com/s/opensans/v40/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0B4gaVc.ttf", fontWeight: 400 },
    { src: "https://fonts.gstatic.com/s/opensans/v40/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsg-1x4gaVc.ttf", fontWeight: 700 },
    { src: "https://fonts.gstatic.com/s/opensans/v40/memQYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWq8tWZ0Pw86hd0Rk5hkaVc.ttf", fontStyle: "italic" },
  ],
});

// Register Lato
Font.register({
  family: "Lato",
  fonts: [
    { src: "https://fonts.gstatic.com/s/lato/v24/S6uyw4BMUTPHjx4wWw.ttf", fontWeight: 400 },
    { src: "https://fonts.gstatic.com/s/lato/v24/S6u9w4BMUTPHh6UVSwiPHA.ttf", fontWeight: 700 },
    { src: "https://fonts.gstatic.com/s/lato/v24/S6u8w4BMUTPHjxsAXC-v.ttf", fontStyle: "italic" },
  ],
});

// Register Montserrat
Font.register({
  family: "Montserrat",
  fonts: [
    { src: "https://fonts.gstatic.com/s/montserrat/v26/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCtr6Ew-Y3tcoqK5.ttf", fontWeight: 400 },
    { src: "https://fonts.gstatic.com/s/montserrat/v26/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCuM70w-Y3tcoqK5.ttf", fontWeight: 700 },
    { src: "https://fonts.gstatic.com/s/montserrat/v26/JTUFjIg1_i6t8kCHKm459Wx7xQYXK0vOoz6jq6R9aX9-p7K5ILg.ttf", fontStyle: "italic" },
  ],
});

// Register Poppins
Font.register({
  family: "Poppins",
  fonts: [
    { src: "https://fonts.gstatic.com/s/poppins/v21/pxiEyp8kv8JHgFVrFJA.ttf", fontWeight: 400 },
    { src: "https://fonts.gstatic.com/s/poppins/v21/pxiByp8kv8JHgFVrLCz7V1s.ttf", fontWeight: 700 },
    { src: "https://fonts.gstatic.com/s/poppins/v21/pxiGyp8kv8JHgFVrJJLed3FBGPaTSQ.ttf", fontStyle: "italic" },
  ],
});

// Register Raleway
Font.register({
  family: "Raleway",
  fonts: [
    { src: "https://fonts.gstatic.com/s/raleway/v34/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVvaorCIPrE.ttf", fontWeight: 400 },
    { src: "https://fonts.gstatic.com/s/raleway/v34/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVs4p7CIPrE.ttf", fontWeight: 700 },
    { src: "https://fonts.gstatic.com/s/raleway/v34/1Pt_g8zYS_SKggPNyCgSQamb1W0lwk4S4WjNDrMfIA.ttf", fontStyle: "italic" },
  ],
});

// Register Nunito
Font.register({
  family: "Nunito",
  fonts: [
    { src: "https://fonts.gstatic.com/s/nunito/v26/XRXI3I6Li01BKofiOc5wtlZ2di8HDLshRTY9jo7eTWk.ttf", fontWeight: 400 },
    { src: "https://fonts.gstatic.com/s/nunito/v26/XRXI3I6Li01BKofiOc5wtlZ2di8HDOUmRTY9jo7eTWk.ttf", fontWeight: 700 },
    { src: "https://fonts.gstatic.com/s/nunito/v26/XRXK3I6Li01BKofIMPyPbj8d7IEAGXNiLXA3iqzbXWnoeg.ttf", fontStyle: "italic" },
  ],
});

// Register PT Serif
Font.register({
  family: "PT Serif",
  fonts: [
    { src: "https://fonts.gstatic.com/s/ptserif/v18/EJRVQgYoZZY2vCFuvAFWzr8.ttf", fontWeight: 400 },
    { src: "https://fonts.gstatic.com/s/ptserif/v18/EJRSQgYoZZY2vCFuvAnt65qVXSr3pA.ttf", fontWeight: 700 },
    { src: "https://fonts.gstatic.com/s/ptserif/v18/EJRTQgYoZZY2vCFuvAFT_r21cg.ttf", fontStyle: "italic" },
  ],
});

// Available font families for customization panel
export const AVAILABLE_FONTS = [
  { label: "Roboto", value: "Roboto" },
  { label: "Open Sans", value: "Open Sans" },
  { label: "Lato", value: "Lato" },
  { label: "Montserrat", value: "Montserrat" },
  { label: "Poppins", value: "Poppins" },
  { label: "Raleway", value: "Raleway" },
  { label: "Nunito", value: "Nunito" },
  { label: "PT Serif", value: "PT Serif" },
];

// Common styles used across all templates
export const commonStyles = StyleSheet.create({
  page: {
    fontFamily: "Roboto",
    fontSize: 10,
    lineHeight: 1.5,
    paddingTop: 30,
    paddingBottom: 30,
    paddingHorizontal: 30,
  },
  section: {
    marginBottom: 10,
  },
  sectionTitle: {
    fontSize: 12,
    fontWeight: 700,
    marginBottom: 5,
    textTransform: "uppercase",
  },
  text: {
    fontSize: 10,
    lineHeight: 1.4,
  },
  bold: {
    fontWeight: 700,
  },
  italic: {
    fontStyle: "italic",
  },
  bulletPoint: {
    fontSize: 10,
    marginBottom: 3,
    paddingLeft: 15,
  },
  link: {
    color: "#0066cc",
    textDecoration: "none",
  },
});

// Format date helper - now uses centralized utility
export const formatDate = (dateString) => {
  return formatDateToMMYYYY(dateString);
};

// Format phone number helper
export const formatPhoneNumber = (phone) => {
  if (!phone) return "";

  // Remove all non-numeric characters
  const cleaned = phone.replace(/\D/g, "");

  // Format as (XXX) XXX-XXXX for US numbers
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }

  return phone;
};

// Format URL helper
export const formatUrl = (url) => {
  if (!url) return "";

  // Remove protocol for display
  return url.replace(/^https?:\/\//, "").replace(/\/$/, "");
};

// Check if the content is a valid summary (not [object Object] variations)
export const isValidSummary = (content) => {
  if (!content || typeof content !== "string") return false;

  const objectStringPatterns = ["[object Object]", "[Object Object]", "[Object object]", "[object object]"];

  const trimmedContent = content.trim();
  return !objectStringPatterns.includes(trimmedContent);
};

// Parse HTML content to plain text
export const parseHtmlToText = (html) => {
  if (!html) return "";

  // Handle various input types safely
  let htmlString = "";

  try {
    if (typeof html === "string") {
      htmlString = html;
    } else if (typeof html === "object" && html !== null) {
      // If it's an object, try to extract text content or convert to JSON
      htmlString = html.toString ? html.toString() : JSON.stringify(html);
    } else {
      // Fallback to string conversion
      htmlString = String(html || "");
    }
  } catch (error) {
    console.warn("Error processing HTML content:", error);
    return "";
  }

  // Check for [object Object] variations and return empty string if found
  const objectStringPatterns = ["[object Object]", "[Object Object]", "[Object object]", "[object object]"];

  if (objectStringPatterns.includes(htmlString.trim())) {
    console.warn("Detected object string pattern in summary, returning empty string:", htmlString);
    return "";
  }

  // Basic HTML tag removal
  try {
    return htmlString
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/?p>/gi, "\n")
      .replace(/<\/?ul>/gi, "\n")
      .replace(/<li>/gi, "• ")
      .replace(/<\/li>/gi, "\n")
      .replace(/<\/?[^>]+(>|$)/g, "")
      .replace(/&nbsp;/g, " ")
      .replace(/&amp;/g, "&")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/\n\s*\n/g, "\n")
      .trim();
  } catch (error) {
    console.warn("Error processing HTML string:", error, "Input:", htmlString);
    return htmlString || "";
  }
};

// Render bullet points from text - Updated to use TextFormattingUtils
export const renderBulletPoints = (text, styles) => {
  if (!text) return null;

  // Safely convert to string
  let textString = "";
  try {
    textString = typeof text === "string" ? text : String(text || "");
  } catch (error) {
    console.warn("Error processing text for bullet points:", error);
    return null;
  }

  // Use centralized bullet point conversion
  const points = convertToBulletPoints(textString);

  return points.map((point, index) => (
    <View key={index} style={{ flexDirection: "row", marginBottom: 4, paddingLeft: 10 }}>
      <Text style={{ fontSize: 10, color: "#333", marginRight: 6, lineHeight: 1.4, marginTop: 0.5 }}>•</Text>
      <Text style={{ fontSize: 10, color: "#333", lineHeight: 1.4, flex: 1 }}>{point}</Text>
    </View>
  ));
};

// Common section components
export const SectionDivider = ({ style }) => (
  <View style={[{ borderBottomWidth: 1, borderBottomColor: "#e0e0e0", marginVertical: 10 }, style]} />
);

export const ContactInfo = ({ data, styles }) => {
  const { email, phone, location, linkedinUrl, githubUrl } = data;
  const items = [];

  if (email) items.push(email);
  if (phone) items.push(formatPhoneNumber(phone));
  if (location) items.push(location);

  return (
    <View style={styles.contactContainer}>
      <Text style={styles.contactText}>{items.join(" • ")}</Text>
      {(linkedinUrl || githubUrl) && (
        <View style={styles.socialLinks}>
          {linkedinUrl && (
            <Link src={linkedinUrl} style={[styles.link, styles.socialLink]}>
              LinkedIn: {formatUrl(linkedinUrl)}
            </Link>
          )}
          {githubUrl && (
            <Link src={githubUrl} style={[styles.link, styles.socialLink]}>
              GitHub: {formatUrl(githubUrl)}
            </Link>
          )}
        </View>
      )}
    </View>
  );
};

// Export base components for templates
export { Document, Page, Text, View, Link };
